import { SideMenuModal } from './SideMenuModal';
import { GiveawayCard } from './GiveawayCard';

interface GiveawayModalProps {
  onClose: () => void;
  showId: string;
  listings: any[];
  activeGiveaway: any;
  giveawayEnded: any;
  onGiveawayEnded: () => void;
}

export function GiveawayModal({
  onClose,
  showId,
  listings,
  activeGiveaway,
  giveawayEnded,
  onGiveawayEnded,
}: GiveawayModalProps) {
  return (
    <SideMenuModal title="Giveaway" onClose={onClose}>
      <GiveawayCard
        showId={showId}
        listings={listings}
        activeGiveaway={activeGiveaway}
        giveawayEnded={giveawayEnded}
        onGiveawayEnded={onGiveawayEnded}
      />
    </SideMenuModal>
  );
}
